import customDialog from './customDialog'
import yxqnSwitch from './yxqnSwitch'
import yxqnPrompt from './yxqnPrompt'
import yxqnAlert from './yxqnAlert'
import GImage from './GImage'
import pageComponents from './pageComponents'
import fixedBottomComponents from './fixedBottomComponents'

export default {
  customDialog,
  yxqnSwitch,
  yxqnPrompt,
  yxqnAlert,
  pageComponents,
  fixedBottomComponents,
  GImage
}
